export const eplOnlySoccerQuery = {
	bool: {
		should: [
			{
				bool: {
					must: [
						{
							term: {
								categoryGroupName: 'FOOTBALL',
							},
						},
						{
							term: {
								eventDisplayName: 'EPL',
							},
						},
					],
				},
			},
			{
				bool: {
					must_not: [
						{
							term: {
								categoryGroupName: 'FOOTBALL',
							},
						},
					],
				},
			},
		],
		minimum_should_match: 1,
	},
};
